export const KWL_INPUT_MAX_LENGTH = 500;
